import React, { Component } from "react";

import { IBarsortingData } from "../../../../../../../../common/types";
import { generatePath } from "../../../../../../../paths";

import { Container, Wrapper, Window } from "../shared-style";
import { getImageDimensions, IGetImageDimensionsThis } from "../methods";

import {
    Bar,
    Mark,
    Marked,
    Counter,
} from "./styles";
import { IProps, IState } from "./interfaces";

const marks = ["A", "B", "C", "D", "E", "F", "G", "H"];

class Same extends Component<IProps, IState> {
    img?: HTMLImageElement;
    constructor(props: IProps) {
        super(props);
        this.state = {
            width: 0,
            height: 0,
            activeType: 0,
            zoom: 1,
        };
        const { task, taskIndex, editTask } = props;
        const { data } = task;
        if (!data.sameTypes) {
            const { systems } = data;
            let sameTypes: IBarsortingData["sameTypes"] = [];
            systems!.starts.forEach((start, index) => {
                sameTypes![index] = [];
            });
            editTask({ taskIndex, changingProp: "sameTypes", val: sameTypes });
            setTimeout(this.save, 100);
        }
    }

    selectBar = (index: number, barIndex: number) => {
        const { task, editTask, taskIndex } = this.props;
        const sameTypes = [...task.data.sameTypes!];
        const { activeType } = this.state;
        sameTypes[activeType].push({ index, barIndex });
        editTask({ taskIndex, changingProp: "sameTypes", val: sameTypes });
        this.save();
    };

    deselectBar = (index: number, barIndex: number) => {
        const { task, editTask, taskIndex } = this.props;
        const sameTypes = [...task.data.sameTypes!];
        sameTypes.forEach((sameType) => {
            sameType.forEach((b, bIndex) => {
                if (b.index === index && b.barIndex === barIndex) {
                    sameType.splice(bIndex, 1);
                }
            });
        });
        editTask({ taskIndex, changingProp: "sameTypes", val: sameTypes });
        this.save();
    };

    save = () => {
        const { plan, taskIndex, post, task } = this.props;
        const {
            data: { sameTypes },
        } = task;
        post("score-editor-same-types", {
            planId: plan._id,
            index: taskIndex,
            sameTypes,
        });
    };

    addSameType() {
        const { task, editTask, taskIndex } = this.props;
        const sameTypes = [...task.data.sameTypes!];
        sameTypes.push([]);
        let activeType = sameTypes.length - 1;
        this.setState({ activeType });
        editTask({ taskIndex, changingProp: "sameTypes", val: sameTypes });
    }

    render() {
        const { task: { data } } = this.props;
        const { score, systems, bars, nonBars, sameTypes } = data;
        const { width, height, activeType, zoom } = this.state;
        return (
            <Container>
                <Wrapper>
                    <img
                        src={generatePath(score!)}
                        ref={img => (this.img = img!)}
                        onLoad={() => getImageDimensions.call(this as unknown as IGetImageDimensionsThis)}
                        width={width}
                        height={height}
                        alt="score"
                    />
                    {!!width &&
                        !!height &&
                        systems!.starts.map((startY, index) => (
                            <Window
                                key={index}
                                style={{
                                    top: startY / zoom,
                                    height: systems!.height / zoom,
                                    left: 0,
                                    right: 0,
                                }}
                            >
                                {[...bars![index], width * zoom].map((bar, barIndex) => {
                                    let lastX = barIndex === 0 ? 0 : bars![index][barIndex - 1];
                                    let width = bar - lastX;
                                    if (
                                        nonBars![index] &&
                                        nonBars![index].findIndex(nonBar => nonBar === barIndex) !== -1
                                    ) {
                                        return null;
                                    }
                                    let marked = -1;
                                    sameTypes!.forEach((sameType, sameTypeIndex) => {
                                        sameType.forEach(b => {
                                            if (b.index === index && b.barIndex === barIndex) {
                                                marked = sameTypeIndex;
                                            }
                                        });
                                    });
                                    return (
                                        <Bar
                                            key={barIndex}
                                            style={{
                                                height: systems!.height / zoom,
                                                left: lastX / zoom,
                                                width: width / zoom,
                                            }}
                                            onClick={() => {
                                                if (marked === -1) {
                                                    this.selectBar(index, barIndex);
                                                } else {
                                                    this.deselectBar(index, barIndex);
                                                }
                                            }}
                                        >
                                            {marked !== -1 && (
                                                <Marked active={activeType === marked}>{marks[marked]}</Marked>
                                            )}
                                        </Bar>
                                    );
                                })}
                            </Window>
                        ))}
                </Wrapper>
                <Mark>
                    {!!sameTypes &&
                        !!sameTypes.length &&
                        [...sameTypes].map((sameType, sameTypeIndex) => {
                            return (
                                <Marked
                                    key={sameTypeIndex}
                                    active={sameTypeIndex === activeType}
                                    add
                                    onClick={() => {
                                        this.setState({ activeType: sameTypeIndex });
                                    }}
                                >
                                    {marks[sameTypeIndex]}
                                    <Counter>{sameType.length}</Counter>
                                </Marked>
                            );
                        })}
                    {!!sameTypes &&
                        !!sameTypes.length &&
                        sameTypes[sameTypes.length - 1].length >= 2 &&
                        sameTypes.length < 8 && (
                            <Marked
                                add
                                onClick={() => {
                                    this.addSameType();
                                }}
                            >
                                +
                            </Marked>
                        )}
                </Mark>
            </Container>
        );
    }
}

export default Same;
